import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SharedUserContextService } from 'user-context';

@Component({
  selector: 'bn-view-select-context',
  templateUrl: './bn-view-select-context.component.html'
})
export class BnViewSelectContextComponent implements OnInit {

  constructor(public readonly userContextService: SharedUserContextService) {}

  ngOnInit() {
    console.log('BnViewSelectContextComponent')
  }

  
}
